import React, { useState } from "react";
import { useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
// import RewardingReadsDB from "./RewardingReadsDB";
import { logout } from '../../redux/actions/authActions';

const RewardingReadsHome = () => {
  const authState = useSelector(state => state.authReducer);
  const { isLoggedIn } = authState;
  const [userName, setUserName] = useState(authState.user.name);
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/rewardingreads");
  };

  const features = [
  {
    title: "Immersive Reading & Speaking Book",
    emoji: "📖",
    desc: "A 100-page interactive book designed for mothers to read, reflect, and engage with their pre-schoolers."
  },
  {
    title: "Chronicle – Digital Diary",
    emoji: "📔",
    desc: "Mothers can log milestones, emotions, and daily events to create a yearly memory book."
  },
  {
    title: "Applause – Celebrate Growth",
    emoji: "👏",
    desc: "Capture and cherish your child’s achievements with Applause entries for lifelong memories."
  },
  {
    title: "Daily Routine Framework",
    emoji: "🕰️",
    desc: "An hour-by-hour guide to balance nutrition, learning, play, and rest for a preschooler."
  },
  {
    title: "Think5Whys Reflection",
    emoji: "🧠",
    desc: "A simple tool for mothers to reflect on challenges and uncover deeper insights in parenting."
  },
  {
    title: "Gamification & Rewards",
    emoji: "🏆",
    desc: "Earn points, rise on the leaderboard, and compete for 'Mother of the Month' awards."
  },
  {
    title: "Community of Mothers",
    emoji: "🤝",
    desc: "Connect with like-minded mothers, share stories, and learn together on the MATRiKA platform."
  },
  {
    title: "MATRiKA Certificate",
    emoji: "📜",
    desc: "Receive recognition for completing your immersive motherhood journey."
  },
  {
    title: "Yearly Subscription Bundle",
    emoji: "💫",
    desc: "All features – book, Chronicle, Applause, tools & awards – under one affordable annual plan."
  }
];


  return (
    <div className="font-sans text-gray-800 bg-gray-100">
      {/* Header */}
      <header className="flex justify-between items-center px-6 py-4 bg-cyan-700 shadow-md sticky top-0 z-50">
        <div className="text-xl font-extrabold text-yellow-200 tracking-wide">Rewarding Reads</div>

        {/* Desktop Menu */}
        <nav className="hidden md:flex space-x-6 font-medium text-gray-700">
          <a href="#whyus" className="text-white hover:text-yellow-200 transition">About</a>
          <Link to="/readers" className="text-white hover:text-yellow-200 transition">Readers</Link>
          <Link to="/authors" className="text-white hover:text-yellow-200 transition">Authors</Link>
          <Link to="/publishers" className="text-white hover:text-yellow-200 transition">Publishers</Link>
        </nav>

        <div className="hidden md:flex items-center space-x-4">
          {isLoggedIn ? (
            <>
              <span className="text-yellow-200 font-medium">Welcome, {userName}</span>
              <button
                onClick={() => navigate(`/sakshamshramdashboard`)}
                className="w-9 h-9 flex items-center justify-center text-lg bg-cyan-500 text-white rounded-lg hover:bg-cyan-600 transition"
                title="Dashboard"
              >
                🏠
              </button>
              <button
                onClick={handleLogout}
                className="w-9 h-9 flex items-center justify-center text-lg bg-red-500 text-white rounded-full hover:bg-red-600 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="px-4 py-2 text-sm border border-cyan-500 text-cyan-600 rounded-full hover:bg-cyan-50 transition"
              >
                Login
              </button>
              <button
                onClick={() => navigate("/signup")}
                className="px-4 py-2 text-sm bg-cyan-600 text-white rounded-full hover:bg-cyan-700 transition"
              >
                Register
              </button>
            </>
          )}
        </div>

        {/* Mobile Hamburger */}
        <div className="md:hidden flex items-center justify-center w-24">
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="text-3xl text-cyan-600 focus:outline-none"
            aria-label="Toggle Menu"
          >
            {isMobileMenuOpen ? "×" : "☰"}
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white px-6 py-4 space-y-1 text-center shadow-md">
          {isLoggedIn && (
            <div className="flex flex-col items-center text-gray-800">
              <p className="text-cyan-600 font-medium">Welcome, {userName}</p>
              <div className="flex space-x-4 mt-2">
                <button
                  onClick={() => navigate(`/sakshamshramdashboard`)}
                  className="w-10 h-10 flex items-center justify-center text-lg bg-cyan-500 text-white rounded-full hover:bg-cyan-600 transition"
                >
                  🏠
                </button>
                <button
                  onClick={handleLogout}
                  className="w-10 h-10 flex items-center justify-center text-lg bg-red-500 text-white rounded-full hover:bg-red-600 transition"
                >
                  ⏻
                </button>
              </div>
            </div>
          )}
          <a href="#whyus" className="block hover:text-cyan-600">About Rewarding Reads</a>
          <Link to="/rewardingreadsupdates" className="block hover:text-cyan-600">News</Link>

          {!isLoggedIn && (
            <div className="flex justify-center space-x-4 pt-2">
              <button className="px-4 py-2 text-sm border border-cyan-500 text-cyan-600 rounded-full hover:bg-cyan-50 transition">Login</button>
              <button className="px-4 py-2 text-sm bg-cyan-600 text-white rounded-full hover:bg-cyan-700 transition">Register</button>
            </div>
          )}
        </div>
      )}

      {/* Hero Section */}
      <section 
        className="relative min-h-[60vh] sm:min-h-[70vh] bg-cover bg-center flex items-center justify-center text-white"
        style={{
          backgroundImage: "url('/assets/banners/rewardingreads.webp')",
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-60"></div>
        <div className="relative z-10 text-center px-4 sm:px-2 md:px-4">
          <h1 className="text-2xl sm:text-2xl lg:text-3xl font-bold mb-2 leading-tight">
            Rewarding Reads
          </h1>
          <p className="text-lg sm:text-xl text-white mb-2 font-semibold">
            Digital engagement platform that transforms traditional reading into an interactive, gamified and rewarding experience..
          </p>
          <div className="flex flex-cols justify-center gap-3">
            {[
              { label: "LoveLines Series - Romance", link: "/rewardingreadsbookshelf" },
              { label: "ThrillQuest Series - Thriller", link: "/rewardingreadsbookshelf" },
              { label: "MindShift Series - Self-Help", link: "/rewardingreadsbookshelf" },
            ].map((btn, idx) => (
              <button
                key={idx}
                onClick={() => window.location.href = btn.link}
                className="w-full px-4 py-3 text-base sm:text-lg font-semibold bg-cyan-600 rounded-lg hover:bg-cyan-700 hover:text-yellow-200 transition"
              >
                {btn.label}
              </button>
            ))}
          </div>
          <div className="flex flex-cols justify-center gap-3">
            {[
              { label: "Meet The Author", link: "/meettheauthor" },
              { label: "AI Counselling", link: "/aicounselling" },
              { label: "Earn", link: "/rewardingreadsearning" },
            ].map((btn, idx) => (
              <button
                key={idx}
                onClick={() => window.location.href = btn.link}
                className="w-full px-4 py-3 text-base sm:text-lg font-semibold bg-cyan-800 rounded-lg hover:bg-cyan-900 hover:text-yellow-200 transition"
              >
                {btn.label}
              </button>
            ))}
          </div>
        </div>
      </section>


      {/* RewardingReads Certificate */}
      {/* <RewardingReadsDB /> */}

      {/* Why Choose Rewarding Reads */}
      <section id="whyus" className="py-4 px-6 md:px-20 bg-gradient-to-r from-cyan-700 to-teal-800">
        <h2 className="text-xl font-bold text-center mb-4 text-white">Why Choose Rewarding Reads?</h2>
        <div className="max-w-6xl mx-auto space-y-6">
          <p className="text-sm leading-relaxed">
            Rewarding Reads is a next-generation digital reading and engagement platform designed to 
            reshape the way readers and authors interact. Unlike conventional e-reading solutions, 
            it integrates <strong>gamification, rewards, and AI-driven analytics</strong> into the reading journey.
          </p>
          <p className="text-sm leading-relaxed">
            It positions itself as the <strong>Duolingo for Reading</strong>, 
            <strong>Goodreads for Engagement</strong>, and <strong>Substack for Author Insights</strong> —
            a unique tri-blend designed for the evolving digital economy.
          </p>
        </div>
        <div className="max-w-6xl mx-auto space-y-8 text-white">
          <p className="text-sm leading-relaxed">
            <strong>Rewarding Reads</strong> is an innovative digital engagement platform that transforms 
            traditional reading into an interactive, gamified and rewarding experience. 
            It bridges the gap between readers and authors through personal autographs, 
            POVs on stories, engagement analytics, AI-powered interactions, and a structured rewards system.
          </p>
          <p className="text-sm leading-relaxed">
            Starting with three high-engagement genres — <em>Romance</em>, <em>Thriller</em>, and <em>Self-Help</em> — 
            Rewarding Reads offers genre-specific modules that create tailored reader journeys while providing 
            authors with valuable insights into how their works are consumed.
          </p>
          <p className="text-sm leading-relaxed">
            Through features like streaks, leaderboards, and personalized AI companions, 
            the platform makes reading social, engaging and measurable. 
            The author dashboard visualizes reader engagement via graphs, logs, and sentiment analysis, 
            empowering creators to continuously refine their craft.
          </p>
        </div>
      </section>

      {/* Executive Summary */}
      {/* <section id="executive" className="py-4 px-6 md:px-20 bg-gradient-to-r from-cyan-600 to-cyan-800 text-white">
        <div className="max-w-6xl mx-auto space-y-6">
          <p className="text-lg leading-relaxed">
            Rewarding Reads is a next-generation digital reading and engagement platform designed to 
            reshape the way readers and authors interact. Unlike conventional e-reading solutions, 
            it integrates <strong>gamification, rewards, and AI-driven analytics</strong> into the reading journey.
          </p>
          <p className="text-lg leading-relaxed">
            It positions itself as the <strong>Duolingo for Reading</strong>, 
            <strong>Goodreads for Engagement</strong>, and <strong>Substack for Author Insights</strong> —
            a unique tri-blend designed for the evolving digital economy.
          </p>
        </div>
      </section> */}

      {/* Genre Modules */}
      <section id="genres" className="py-4 px-6 md:px-20 bg-gradient-to-r from-cyan-600 to-cyan-800 text-white">
        <h2 className="text-xl font-bold text-center mb-4">Genre Modules</h2>
        <div className="grid grid-cols-3 md:grid-cols-3 gap-8 text-center">
          
          <div className="bg-white/10 p-8 rounded-xl shadow-lg hover:bg-white/20 transition">
            <h3 className="text-lg font-semibold mb-3">💖 Rewarding Reads: LoveLines</h3>
            <p className="text-sm">“Every page turned brings you closer to love and rewards.”</p>
          </div>

          <div className="bg-white/10 p-8 rounded-xl shadow-lg hover:bg-white/20 transition">
            <h3 className="text-lg font-semibold mb-3">🕵️ Rewarding Reads: ThrillQuest</h3>
            <p className="text-sm">“Crack the clues, unlock rewards, outsmart the story.”</p>
          </div>

          <div className="bg-white/10 p-8 rounded-xl shadow-lg hover:bg-white/20 transition">
            <h3 className="text-lg font-semibold mb-3">🧠 Rewarding Reads: MindShift</h3>
            <p className="text-sm">“Read, reflect, and be rewarded for your growth.”</p>
          </div>
        </div>
      </section>

      {/* Features / Ecosystem Tabs */}
      <section id="features" className="py-4 px-6 md:px-20 bg-gradient-to-r from-cyan-800 to-teal-800 text-white">
        <h2 className="text-xl font-bold text-center mb-4">Rewarding Reads Ecosystem</h2>
        <div className="grid grid-cols-3 sm:grid-cols-6 lg:grid-cols-6 gap-2">
          {[
            "Reader’s Rewards", "Profile", "Seek Autograph", "Certified by Author", 
            "Micro-Points & Streaks Wallet", "Meso-Rankings & Prizes", "Macro-Meet The Author",
            "Refer & Earn", "Reading Heatmap", "Reading Notes", "Author Dashboard", 
            "Author Tools", "Book Ranking", "Engagement Heatmap", "Sentiment Graph", 
            "Give Autograph", "Readers Ratings", "Readers Request"
          ].map((item, idx) => (
            <div key={idx} className="bg-white/10 p-6 rounded-lg shadow-md hover:bg-white/20 transition">
              <p className="text-sm font-semibold">{item}</p>
            </div>
          ))}
        </div>
      </section>



      {/* Footer */}
      <footer className="bg-cyan-700 text-white py-10 px-4 sm:px-6 md:px-20">
        <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left">
          <p className="text-sm">&copy; 2025 Think5Whys Global DeepTech Solutions. All rights reserved.</p>
          <div className="flex space-x-6 mt-4 md:mt-0 text-sm">
            <Link to="/about-us" className="text-white hover:text-cyan-400 transition">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-cyan-400 transition">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-cyan-400 transition">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-cyan-400 transition">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default RewardingReadsHome;
